<template>
  <jet-authentication-card>
    <card-header>Register as Clinician</card-header>
    <template #logo>
      <jet-authentication-card-logo />
    </template>

    <jet-validation-errors class="mb-4" />

    <form @submit.prevent="submit" class="p-6 relative">
      <div>
        <jet-label for="name" value="Name" />
        <jet-input
          id="name"
          type="text"
          name="name"
          class="mt-1 block w-full"
          v-model="form.name"
          required
          autofocus
          autocomplete="name"
        />
      </div>
      <div class="mt-4">
        <jet-label for="phone" value="Phone" />
        <vue-tel-input
          v-model="form.phone"
          id="phone"
          ref="phone"
          class="mt-1 h-9"
          :defaultCountry="'GB'"
          :mode="'international'"
          :ignoredCountries="['RU']"
          :inputOptions="{ showDialCode: true }"
        ></vue-tel-input>
      </div>
      <div class="mt-4">
        <jet-label for="email" value="Email" />
        <jet-input
          id="email"
          type="email"
          name="email"
          class="mt-1 block w-full"
          v-model="form.email"
          required
          autocomplete="on"
        />
      </div>

      <div class="mt-4">
        <jet-label for="password" value="Password" />
        <jet-input
          id="password"
          :type="fieldType"
          name="password"
          class="mt-1 block w-full"
          v-model="form.password"
          required
          autocomplete="new-password"
        />
        <TogglePassword
          @fieldTypeChanged="fieldTypeChanged"
          :password="form.password"
        ></TogglePassword>
      </div>

      <div class="mt-4">
        <jet-label for="password_confirmation" value="Confirm password" />
        <jet-input
          id="password_confirmation"
          :type="confirmationFieldType"
          name="password_confirmation"
          class="mt-1 block w-full"
          v-model="form.password_confirmation"
          required
          autocomplete="new-password"
        />
        <TogglePassword
          @fieldTypeChanged="confirmationFieldTypeChanged"
          :password="form.password_confirmation"
        ></TogglePassword>
      </div>

      <div class="mt-4" v-if="$page.props.jetstream.hasTermsAndPrivacyPolicyFeature">
        <jet-label for="terms">
          <div class="flex items-center">
            <jet-checkbox name="terms" id="terms" v-model:checked="form.terms" />

            <div class="ml-2">
              I agree to the
              <a
                target="_blank"
                :href="route('terms.show')"
                class="underline text-sm text-gray-600 hover:text-gray-900"
              >
                Terms of service
              </a>
              and
              <a
                target="_blank"
                :href="route('policy.show')"
                class="underline text-sm text-gray-600 hover:text-gray-900"
              >
                Privacy Policy
              </a>
            </div>
          </div>
        </jet-label>
      </div>

      <div class="flex items-center justify-end mt-4">
        <inertia-link
          :href="route('clinician.showLogin')"
          class="font-medium text-vice-teal-700 hover:text-vice-teal-600 text-sm"
        >
          Already registered?
        </inertia-link>

        <jet-button
          class="ml-4"
          :class="{ 'opacity-25': form.processing }"
          :disabled="form.processing"
        >
          Register
        </jet-button>
      </div>
    </form>
  </jet-authentication-card>
</template>

<script>
import { VueTelInput } from 'vue-tel-input';
import JetAuthenticationCard from '@/Jetstream/AuthenticationCard.vue';
import JetAuthenticationCardLogo from '@/Jetstream/AuthenticationCardLogo.vue';
import JetButton from '@/Jetstream/Button.vue';
import JetInput from '@/Jetstream/Input.vue';
import JetCheckbox from '@/Jetstream/Checkbox.vue';
import JetLabel from '@/Jetstream/Label.vue';
import JetValidationErrors from '@/Jetstream/ValidationErrors.vue';
import CardHeader from '@/Components/Cards/CardHeader.vue';
import TogglePassword from '@/Components/Badges/TogglePassword.vue';

export default {
  components: {
    CardHeader,
    JetAuthenticationCard,
    JetAuthenticationCardLogo,
    JetButton,
    JetInput,
    JetCheckbox,
    JetLabel,
    JetValidationErrors,
    TogglePassword,
    VueTelInput,
  },

  data() {
    return {
      form: this.$inertia.form({
        name: '',
        email: '',
        phone: '',
        password: '',
        password_confirmation: '',
        terms: false,
      }),
      fieldType: 'password',
      confirmationFieldType: 'password',
    };
  },

  methods: {
    submit() {
      this.form.post(this.route('clinician.register'), {
        onFinish: () => this.form.reset('password', 'password_confirmation'),
      });
    },
    fieldTypeChanged(e) {
      this.fieldType = e;
    },
    confirmationFieldTypeChanged(e) {
      this.confirmationFieldType = e;
    },
  },
  watch: {
    'form.phone': {
      handler(newVal) {
        if (newVal) this.form.phone = this.form.phone.replace(/\s+/g, '');
      },
    },
  },
};
</script>
